import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { BaseApiTemplateService } from '../../shared/base-api-template-service.model';
import { Core2Config } from '../../shared';
import { FinancialItemCategoryFileImportContainer } from '../../../../../../models';

@Injectable({
  providedIn: 'root'
})
export class FinancialItemCategoryFileImportService extends BaseApiTemplateService<FinancialItemCategoryFileImportContainer> {
  readonly url = Core2Config.DOMAIN_URL + Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/import-file-helper/backoffice-ep/with-category';

  constructor(http: HttpClient) {
    super();
    this.apiUrl = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/import-file-helper/backoffice-ep/with-category';
    this.endpoint_path = Core2Config.TENANT_DOMAIN_URL_PREFIX + Core2Config.ERP_PREFIX + Core2Config.FI_PREFIX + 'fi-items/import-file-helper/backoffice-ep/with-category';
    this.httpClient = http;
  }
}